import React from 'react';

import './light.css';

export default (props) =>
  <div className="led-box">
    <div className={ props.blink ? `led led-${props.color} blinking` : `led led-${props.color}`}></div>
  </div>
